import { IPaginatedResponse, IResponse } from "../../../model";
import ServiceBase from "../../../servicebase";
import { IRibbon } from "../model/IRibbon";

export default class RibbonService extends ServiceBase {
  
  get = (data:{ id?: number }) : Promise<IResponse<IRibbon>> => 
    this.GetFetch<IResponse<IRibbon>>('entity/ribbon', data);

  find = (data:{ pageIndex?: number, pageSize?: number, sort?: string,
    cliente?: string, cotizador?: string, proveedor?: string, producto?: string, origen?: string; mensaje?: string, vigencia?: Date, activo?: boolean }) : Promise<IPaginatedResponse<IRibbon>> => 
    this.GetFetch<IPaginatedResponse<IRibbon>>('entity/ribbon/find', data);
    
  upsert = (data: IRibbon) : Promise<IResponse<IRibbon>> => 
    this.PostFetch<IResponse<IRibbon>>('entity/ribbon', data);

}
